import {AgGridVue} from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import moduleSkills from "@/store/skills/moduleSkills.js";
import moduleBreaks from "@/store/breaks/moduleBreaks.js";
import moduleCapacity from "@/store/capacity/moduleCapacity.js";
import moduleTeams from "@/store/teams/moduleTeams.js";
import moduleDepot from "@/store/depot/moduleDepot.js";
import CellRendererLink from "@/components/vehicle/list/cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "@/components/vehicle/list/cell-renderer/CellRendererStatus.vue";
import CellRendererProfile from "@/components/vehicle/list/cell-renderer/CellRendererProfile.vue";
import CellRendererActions from "@/components/vehicle/list/cell-renderer/CellRendererActions.vue";
import CellRendererAdditionalFields from "@/components/vehicle/list/cell-renderer/CellRendererAdditionalFields.vue";
import CellRendererDemandText from "@/components/vehicle/list/cell-renderer/demand/CellRendererDemandText.vue";
import CellRendererDemand from "@/components/vehicle/list/cell-renderer/demand/CellRendererDemand.vue";

window.numberParserVehicle = function numberParserVehicle(params) {
	return Number(params.newValue) | 0;
};

export const vehicleListMixin = {
	name: "VehicleList",
	props: {
		customConfig: {
			type: Object,
			default: () => {
				return {
					rowSelection: "multiple",
					activeCheckbox: false,
					columns: [],
					tableOptions: true,
					showItemsPerPage: true,
					cellRendererAdditionalFields: false,
					CellRendererDemand: false,
					showPopup: false,
					showButtonAdd: true,
					showButtonSelected: false,
				};
			},
		},
		relatedIds: {
			type: Array,
			default: () => [],
		},
		componentParent: {
			type: String,
			default: "VEHICLE_LIST",
		},
		pagination: {
			type: Object,
			default: () => {
				return {
					next_page: 0,
					total_pages: 0,
					total_records: 0,
				};
			},
		},
	},
	components: {
		AgGridVue,
		vSelect,
		CellRendererLink,
		CellRendererStatus,
		CellRendererProfile,
		CellRendererActions,
		CellRendererAdditionalFields,
		CellRendererDemand,
		CellRendererDemandText,
	},
	data() {
		return {
			roleFilter: {label: "All", value: "all"},
			statusFilter: {label: "All", value: "all"},
			isVerifiedFilter: {label: "All", value: "all"},
			departmentFilter: {label: "All", value: "all"},
			searchQuery: [],
			currentPageLocal: 1,
			quantityElementPage: this.componentParent === "OPTIMIZATION" ? 20 : 10,
			searchField: "Identification",
			gridApi: null,
			gridOptions: {},
			infoSelected: null,
			isExactly: false,
			arrayInfo: [],
			showSelected: false,
			showSearch: false,
			alertCode: false,
			defaultColDef: {
				sortable: true,
				resizable: true,
				suppressMenu: true,
			},
			components: {
				CellRendererLink,
				CellRendererStatus,
				CellRendererProfile,
				CellRendererActions,
				CellRendererAdditionalFields,
				CellRendererDemand,
				CellRendererDemandText,
			},
			profileOptions: [
				{
					name: this.$t("Routing.Car"),
					id: "car",
				},
				{
					name: this.$t("Routing.Walking"),
					id: "walk",
				},
				{
					name: this.$t("Routing.Bicycle"),
					id: "bicycle",
				},
				{
					name: this.$t("Routing.Motorcycle"),
					id: "motorcycle",
				},
				{
					name: this.$t("Routing.Truck"),
					id: "truck",
				},
				{
					name: this.$t("Routing.Scooter"),
					id: "scooter",
				},
				{
					name: this.$t("Routing.Bus"),
					id: "bus",
				},
			],
		};
	},
	watch: {
		currentPageLocal(page) {
			this.getVehicles(page);
		},
		quantityElementPage() {
			this.getVehicles(1);
		},
		searchField(val) {
			this.infoSelected = null;
			if (val === "Profile") {
				this.getData(this.profileOptions);
			} else if (val === "TeamsTable") {
				this.$store.dispatch("moduleTeams/fetchDataListItems").then((res) => {
					this.getData(res.data);
				});
			} else if (val === "SkillsTable") {
				this.$store.dispatch("moduleSkills/fetchDataListItems").then((res) => {
					this.getData(res.data);
				});
			} else if (val === "Breaks") {
				this.$store.dispatch("moduleBreaks/fetchDataListItems").then((res) => {
					this.getData(res.data);
				});
			} else if (val === "Capabilities") {
				const payload = {
					page: 1,
					sort: "desc",
					order_by: ["id"],
				};
				this.$store
					.dispatch("moduleCapacity/findCapacityFilter", payload)
					.then((res) => this.getDataCapacity(res.records));
			} else if (val === "StartDeposit" || val === "EndDeposit") {
				this.$store.dispatch("moduleDepot/fetchDataListItems").then((res) => {
					this.getData(res.data);
				});
			}
		},
	},
	computed: {
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
				}
			},
		},
		overlayLoadingTemplate() {
			return `<div class="ring">${this.$t("Loading")}<span></span></div>`;
		},
		overlayNoRowsTemplate() {
			return `<span style="font-size: 14px; font-weight: 500; color: grey">${this.$t("NoDataAvailable")}</span>`;
		},
		columnDefs() {
			let filterHead = this.customConfig.filterHead !== undefined ? this.customConfig.filterHead : true;
			let columns = [
				{
					headerName: "ID",
					field: "id",
					width: 250,
					filter: filterHead,
					checkboxSelection: this.customConfig.activeCheckbox,
					headerCheckboxSelectionFilteredOnly: true,
					headerCheckboxSelection: this.customConfig.activeHeaderCheckboxSelection,
					cellRendererFramework: this.customConfig.activeLink ? "CellRendererLink" : null,
					pinned: this.customConfig.activeCheckbox ? "left" : "",
				},
				{
					headerName: this.$t("Routing.Table.Identification"),
					field: "identification",
					filter: filterHead,
					width: 350,
				},
				{
					headerName: this.$t("Profile"),
					field: "profile",
					filter: filterHead,
					width: 100,
					cellRendererFramework: "CellRendererProfile",
				},
				{
					headerName: this.$t("Routing.DistanceRoute") + "(Mts)",
					field: "max_travel_distance",
					filter: filterHead,
					width: 160,
				},
				{
					headerName: "T. " + this.$t("Vehicles.Service"),
					field: "max_travel_duration",
					filter: filterHead,
					width: 130,
				},
				{
					headerName: this.$t("Deposits.Form.StartDeposit"),
					field: "init_depot_name",
					filter: filterHead,
					width: 330,
				},
				{
					headerName: this.$t("Deposits.Form.EndDeposit"),
					field: "end_depot_name",
					filter: filterHead,
					width: 330,
				},
				{
					headerName: this.$t("ResourceModule.Table.Actions"),
					field: "transactions",
					width: 120,
					cellRendererFramework: "CellRendererActions",
					pinned: "right",
				},
			];
			if (this.customConfig.cellRendererAdditionalFields) {
				columns.push({
					headerName: this.$t("AdditionalFields"),
					field: "additional_info",
					width: 350,
					filter: filterHead,
					cellRendererFramework: "CellRendererAdditionalFields",
				});
			}
			if (this.customConfig.CellRendererDemand) {
				columns.splice(2, 0, {
					headerName: this.$t("Capacity.Capacity"),
					field: "demand",
					filter: filterHead,
					editable: true,
					width: 130,
					valueParser: numberParserVehicle,
					cellRendererFramework: "CellRendererDemandText",
				});
			}
			const showColumns =
				this.customConfig.columns !== undefined && this.customConfig.columns.length > 0
					? this.customConfig.columns
					: [];
			if (showColumns.length > 0) {
				columns = columns.filter((column) => {
					if (showColumns.includes(column.field)) {
						return column;
					}
				});
			}

			return columns;
		},
		paginationPageSize() {
			if (this.pagination.total_records > 0) {
				return this.pagination.total_records;
			} else {
				return 0;
			}
		},
		totalPages() {
			if (this.pagination.total_pages > 0) return this.pagination.total_pages;
			else return 0;
		},
		currentPage: {
			get() {
				return this.currentPageLocal;
			},
			set(val) {
				this.currentPageLocal = val;
			},
		},
		searchSelected() {
			return this.$t(`${this.searchField}`);
		},
		listData() {
			return this.$store.state.vehicle.vehicles;
		},
		getCheckedVehicles() {
			return this.$store.state.vehicle.checkedVehicles;
		},
		searchFieldSelected() {
			if (this.searchField === "SkillsTable") return "SkillsTable";
			else if (this.searchField === "Breaks") return "Breaks";
			else if (this.searchField === "Capabilities") return "Capabilities";
			else if (this.searchField === "TeamsTable") return "TeamsTable";
			else if (this.searchField === "StartDeposit") return "StartDeposit";
			else if (this.searchField === "EndDeposit") return "EndDeposit";
			else if (this.searchField === "Profile") return "Profile";
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		isWidthPortatil() {
			return window.innerWidth <= 1366;
		},
		iconSize() {
			return this.$store.state.windowWidth < 620 ? "small" : "medium";
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		onBtShowLoading() {
			this.gridApi.showLoadingOverlay();
		},
		onBtHide() {
			this.gridApi.hideOverlay();
		},
		getVehicles(page) {
			this.onBtShowLoading();
			const payload = {
				page,
				quantity: this.quantityElementPage,
				match_filter: !this.isExactly,
				sort: "desc",
				order_by: ["id"],
			};
			this.$store
				.dispatch("vehicle/findVehiclePaginated", payload)
				.then((res) => {
					Object.assign(this.pagination, res.pagination);
					setTimeout(() => {
						this.resetColFilters();
						this.setDefaultSelectedRow();
					}, 100);
					this.onBtHide();
				})
				.catch((err) => {
					this.onBtHide();
					console.error(err);
				});
		},
		setColumnFilter(column, val) {
			const filter = this.gridApi.getFilterInstance(column);
			let modelObj = null;
			if (val !== "all") {
				modelObj = {type: "equals", filter: val};
			}
			filter.setModel(modelObj);
			this.gridApi.onFilterChanged();
		},
		resetColFilters() {
			this.gridApi.setFilterModel(null);
			this.gridApi.onFilterChanged();
		},
		updateSearchQuery(val) {
			this.gridApi.setQuickFilter(val);
		},
		searchVehicle() {
			const searchQueryList = this.searchQuery.map(({value}) => value);
			const dataPage = {
				identification: this.searchField === "Identification" ? searchQueryList : [],
				profile: this.searchField === "Profile" ? this.infoSelected.map(({value}) => value) : [],
				skill_id: this.searchField === "SkillsTable" ? this.infoSelected.map(({value}) => value) : [],
				break_id: this.searchField === "Breaks" ? this.infoSelected.map(({value}) => value) : [],
				capacities:
					this.searchField === "Capabilities" ? this.infoSelected.map(({infoCapacity}) => infoCapacity) : [],
				team_id: this.searchField === "TeamsTable" ? this.infoSelected.map(({value}) => value) : [],
				init_depot_id: this.searchField === "StartDeposit" ? this.infoSelected.map(({value}) => value) : [],
				end_depot_id: this.searchField === "EndDeposit" ? this.infoSelected.map(({value}) => value) : [],
				match_filter: !this.isExactly,
				order_by: ["id"],
				sort: "asc",
			};
			this.onBtShowLoading();
			this.$store
				.dispatch("vehicle/findVehiclePaginated", dataPage)
				.then((res) => {
					Object.assign(this.pagination, res.pagination);
					setTimeout(() => {
						this.resetColFilters();
						this.setDefaultSelectedRow();
					}, 100);
					this.onBtHide();
				})
				.catch((err) => {
					this.onBtHide();
					console.error(err);
				});
		},
		searchAssignedVehicle(searchField, searchQuery, page) {
			const searchQueryList = searchQuery.map(({value}) => value);
			const dataPage = {
				identification: searchField === "Identification" ? searchQueryList : [],
				profile: searchField === "Profile" ? searchQuery : [],
				skill_id: searchField === "SkillsTable" ? searchQuery : [],
				break_id: searchField === "Breaks" ? searchQuery : [],
				capacities: searchField === "Capabilities" ? searchQuery : [],
				team_id: searchField === "TeamsTable" ? searchQuery : [],
				init_depot_id: searchField === "DepositInit" ? searchQuery : [],
				end_depot_id: searchField === "DepositEnd" ? searchQuery : [],
				page: page ? page : currentPageLocal,
				match_filter: !this.isExactly,
				order_by: ["id"],
				sort: "asc",
			};
			this.onBtShowLoading();
			this.$store
				.dispatch("vehicle/findVehiclePaginated", dataPage)
				.then((res) => {
					Object.assign(this.pagination, res.pagination);
					setTimeout(() => {
						this.resetColFilters();
						this.setDefaultSelectedRow();
					}, 100);
					this.onBtHide();
				})
				.catch((err) => {
					this.onBtHide();
					console.error(err);
				});
		},
		generateOptionSelect(data, propLabel, propValue) {
			return data.map((d) => {
				return {label: d[propLabel], value: d[propValue]};
			});
		},
		paginationSetPageSize(num) {
			this.gridApi.paginationSetPageSize(num);
			this.quantityElementPage = num;
		},
		rowSelected(event) {
			const isSelected = event.node.isSelected();
			if (isSelected) {
				this.$store.commit("vehicle/ADD_VEHICLE_CHECKED", event.data);
			} else {
				this.$store.commit("vehicle/REMOVE_VEHICLE_CHECKED", event.data);
			}
		},
		onSelectionChanged() {
			const selectedRows = this.getCheckedVehicles;
			if (this.customConfig.rowSelection === "single") {
				this.$store.dispatch("vehicle/currentVehicleSelected", selectedRows[0]);
			}
		},
		setDefaultSelectedRow() {
			const relatedIds = this.getCheckedVehicles;
			if (relatedIds.length > 0) {
				this.gridApi.forEachNode((node) => {
					const valid = relatedIds.some((r) => r.id === node.data.id);
					node.setSelected(valid);
				});
			}
		},
		refreshVehicle() {
			this.searchQuery = [];
			this.currentPageLocal = 1;
			this.infoSelected = null;
			this.showSelected = false;
			this.showSearch = false;
			this.$store.commit("vehicle/REMOVE_ALL_VEHICLE_CHECKED");
			this.getVehicles(1);
		},
		setSearchField(val) {
			this.searchField = val;
		},
		updateDemand(amount) {
			if (this.getCheckedVehicles.length > 0) {
				this.getCheckedVehicles.forEach((vehicle) => {
					this.listData.forEach((item) => {
						if (vehicle.id === item.id) item.demand = amount;
					});
				});
				this.gridApi.setRowData(this.listData);
				this.setDefaultSelectedRow();
			}
		},
		async updateMatchFilter() {
			const payload = {};
			payload["filter_exact_vehicle"] = this.isExactly;
			try {
				await this.$store.dispatch("moduleMatchFilter/updateMatchFilter", payload);
			} catch (error) {
				this.$vs.notify({
					color: "danger",
					title: this.$t("ErrorTitle"),
					text: this.$t("ErrorMessage"),
				});
			}
		},
		openEnableConfirm(val) {
			if (val) {
				this.$vs.dialog({
					type: "confirm",
					color: "primary",
					title: this.$t("Confirm"),
					text: `${this.$t("Preferences.FilterSearchExactText")}`,
					accept: () => {
						this.isExactly = val;
						this.updateMatchFilter();
					},
					cancel: () => {
						this.isExactly = false;
					},
					acceptText: this.$t("Accept"),
					cancelText: this.$t("Cancel"),
				});
			} else {
				this.isExactly = val;
				this.updateMatchFilter();
			}
		},
		getData(data) {
			this.arrayInfo = data.map((info) => {
				return {label: info.name, value: info.id};
			});
		},
		getDataCapacity(data) {
			this.arrayInfo = data.map((info) => {
				return {
					label: info.name,
					value: info.id,
					infoCapacity: {capacity_id: info.id, amount: info.resources != null ? info.resources[0].amount : 0},
				};
			});
		},
		selectedVehicles(initValue) {
			if (this.getCheckedVehicles.length >= initValue) {
				this.gridApi.setRowData(this.getCheckedVehicles);
				this.setDefaultSelectedRow();
				this.showSelected = true;
			}
		},
		removeChips() {
			this.infoSelected = null;
			this.showSelected = false;
			this.searchQuery = [];
			if (this.getCheckedVehicles.length > 0 && !this.showSearch) {
				this.gridApi.setRowData(this.listData);
				this.setDefaultSelectedRow();
			} else {
				this.showSearch = false;
				this.getVehicles();
			}
		},
	},
	async mounted() {
		this.gridApi = this.gridOptions.api;
		if (this.$vs.rtl) {
			const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container");
			header.style.left = `-${String(Number(header.style.transform.slice(11, -3)) + 9)}px`;
		}
		const matchFilter = await this.$store.dispatch("moduleMatchFilter/getMatchFilter");
		if (Object.entries(matchFilter) > 0) {
			this.isExactly = matchFilter.filter_exact_vehicle;
		} else {
			this.isExactly = this.$store.state.moduleMatchFilter.filter_exact_vehicle;
		}
		this.$emit("gridApiEmit", this.gridApi);
		if (this.componentParent != "OPTIMIZATION") this.getVehicles(1);
	},
	created() {
		if (!moduleSkills.isRegistered) {
			this.$store.registerModule("moduleSkills", moduleSkills);
			moduleSkills.isRegistered = true;
		}
		if (!moduleBreaks.isRegistered) {
			this.$store.registerModule("moduleBreaks", moduleBreaks);
			moduleBreaks.isRegistered = true;
		}
		if (!moduleCapacity.isRegistered) {
			this.$store.registerModule("moduleCapacity", moduleCapacity);
			moduleCapacity.isRegistered = true;
		}
		if (!moduleTeams.isRegistered) {
			this.$store.registerModule("moduleTeams", moduleTeams);
			moduleTeams.isRegistered = true;
		}
		if (!moduleDepot.isRegistered) {
			this.$store.registerModule("moduleDepot", moduleDepot);
			moduleDepot.isRegistered = true;
		}
	},
	beforeDestroy() {
		if (this.componentParent != "OPTIMIZATION") this.$store.commit("vehicle/REMOVE_ALL_VEHICLE_CHECKED");
	},
};
